export default {
    header_menu: {
        home: "首页",
        about: "关于我们",
        product: "产品中心",
        news: "新闻资讯",
        news_content: "新闻详情",
        download: "下载中心",
        contact: "联系我们",
    },
    read_more: "阅读更多",
    prev: "上一篇",
    next: "下一篇",
    quick_navigation: "快捷导航",
    phone: "电话",
    whatsapp: "WhatsApp",
    email: "邮箱",
    address: "地址",
    your_name: "您的姓名",
    your_email: "您的邮箱",
    content: "内容",
    please_input: "请输入",
    leave_message: "发送询盘",
    leave_success: "发送成功",
    click_count: "点击次数",
    create_time: "创建时间",
    upload_time: "上传时间",
    //下载（动作）
    download: "下载",
    resources: "资源",
    products_type1: "产品分类",
    products_type2: "子分类",
    products_type3: "子分类",
    products_list: "产品列表",
    products_detail: "产品详情",
    products_video: "产品视频",
    send_message: "发送询盘",
    products_content: "产品内容",
    categories: "产品分类",
    send_email: "发送邮件",
    call_time: "服务时间",
    our_location: "我们的位置",
    leave_message_to_us: "向我们发送询盘",
    left_category: "分类",
    type_two: "子分类",
    type_three: "子分类",
    video_not_support: "您的浏览器不支持 video 标签。",
    about_us: "关于我们",
    no_data: "暂无数据",
    home_about_subtitle: "面向全球客户的优质木材与胶合板可信供应商",
    home_products_title: "核心产品",
    home_products_subtitle: "探索我们的核心产品分类",
    view_all: "查看全部",
    home_stat_countries: "服务国家",
    home_stat_capacity: "年产能（立方米）",
    home_stat_years: "行业经验（年）",
    home_stat_clients: "全球客户",
    footer_follow: "微信扫码关注我们",
    footer_wechat: "微信",
    footer_copyright: "德佰木业 版权所有",
    home_visual_year: "始于 2009 年",
    home_visual_quote: "服务全球 60+ 国家采购商的优质木材与胶合板合作伙伴。",
    home_visual_tag: "FSC · ISO 9001 · CE 认证",
    cta_title: "在寻找可靠的木材与胶合板供货商吗？",
    cta_sub: "为您的大批量木材订单提供具竞争力的报价与全球配送。",
    get_a_quote: "获取报价",
    home_banner_title: "面向全球的优质木材与胶合板",
    home_banner_sub: "服务全球 60+ 国家，FSC、ISO 9001、CE 认证品质，值得信赖。",
    topbar_slogan: "优质木材与胶合板 — 全球采购商信赖之选",
    contact_hero_tag: "取得联系",
    page_title: {
        home: "德佰木业 | 木材与胶合板制造商及全球供应商",
        about: "关于我们 | 德佰木业",
        products: "产品中心 | 德佰木业",
        news: "新闻动态 | 德佰木业",
        download: "下载中心 | 德佰木业",
        contact: "联系我们 | 德佰木业",
        not_found: "页面未找到",
        back_home: "返回首页",
    },
}
